const defaultMyRedirect =
  process.env.NEXT_PUBLIC_BASE_URL_MY || 'https://my.compassion.com';

const defaultAuthRedirect =
  process.env.NEXT_PUBLIC_FF_DEFAULT_TO_MY === 'true'
    ? defaultMyRedirect
    : process.env.NEXT_PUBLIC_BASE_URL_DOTCOM || 'https://www.compassion.com';

export const defaultAuthRedirectUrl = new URL(defaultAuthRedirect);
export const defaultMyRedirectUrl = new URL(defaultMyRedirect);

/**
 * Returns true when `redirectUrl` belongs to the trusted environment
 * root (`trustedDomain`).
 */
export const isTrustedRedirect = (
  redirectUrl: URL | null,
  trustedDomain: string | null,
): boolean => {
  if (!redirectUrl || !trustedDomain) {
    return false;
  }

  const hostname = redirectUrl.hostname.toLocaleLowerCase();
  const normalizedTrustedDomain = trustedDomain.toLocaleLowerCase();
  const writeUrl = process.env.NEXT_PUBLIC_BASE_URL_WRITE;

  // Only trust the redirect when it's on our environment root and uses
  // an http(s) protocol (rejects javascript:, data:, etc.).
  return (
    (hostname === normalizedTrustedDomain ||
      hostname.endsWith(`.${normalizedTrustedDomain}`) ||
      // Temporary for allowing write-test and write-stage
      (!!writeUrl &&
        URL.canParse(writeUrl) &&
        hostname === new URL(writeUrl).hostname.toLocaleLowerCase())) &&
    (redirectUrl.protocol === 'https:' || redirectUrl.protocol === 'http:')
  );
};
